import React, {useEffect} from 'react';
import Subscribe from './Subscribe';

const ContactDetails = () => {

    useEffect(() => {
        const form = document.getElementById('contact-form') as HTMLFormElement;
        if (form) {
          const handleSubmit = async (event: Event) => {
            event.preventDefault();
    
            // Get the form data
            const formData = new FormData(form);
    
            // Construct the email subject
            const subject = formData.get('subject')?.toString() || '';
    
            // Create the message string, excluding file inputs
            const message = Array.from(formData.entries())
              .filter(([name, value]) => name !== 'file' && value !== null)
              .map(([name, value]) => `${name}: ${value}`)
              .join('\n');
    
            // Construct the mailto URL with the email subject and body
            const mailtoURL = `mailto:reddyg.spurthi@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(message)}`;
    
            // Open the user's email client with the pre-filled message
            window.location.href = mailtoURL;
          };
    
          form.addEventListener('submit', handleSubmit);
    
          return () => {
            form.removeEventListener('submit', handleSubmit);
          };
        }
      }, []); // Empty dependency array ensures the effect runs only once when the component mounts
    

  return (
            <>
                <section className="contact-info-section centred">
                    <div className="auto-container">
                        <div className="row clearfix">
                            <div className="col-lg-4 col-md-6 col-sm-12 info-column">
                                <div className="single-item">
                                    <div className="icon-box"><i className="icon-57"></i></div>
                                    <h3>Hospital Location</h3>
                                    <p><a href="https://maps.app.goo.gl/Coc7TBGjEj715mDs6" target="_blank" rel="noopener noreferrer">D.No.87-1165, Hosanna Mandir Road, Nandyal Road, Revenue Colony, Kurnool, Andhra Pradesh 518002, India</a></p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 info-column">
                                <div className="single-item">
                                    <div className="icon-box"><i className="icon-58"></i></div>
                                    <h3>Hospital Email</h3>
                                    <p>
                                    <a href="mailto:reddyg.spurthi@gmail.com">reddyg.spurthi@gmail.com</a><br />
                                    {/* <a href="mailto:reddyg.spurthi@gmail.com">reddyg.spurthi@gmail.com</a> */}
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 info-column">
                                <div className="single-item">
                                    <div className="icon-box"><i className="icon-59"></i></div>
                                    <h3>Contact Us</h3>
                                    <p><a href="tel:9963276070">+(91) 9963276070</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Comment form hidden */}
                <section className="contact-style-two p_relative" style={{display: 'none'}}>
                    <div className="pattern-layer">
                        <div className="pattern-1" style={{backgroundImage: `url(assets/images/shape/shape-55.png)`}}></div>
                        <div className="pattern-2" style={{backgroundImage: 'url(assets/images/shape/shape-56.png)'}}></div>
                    </div>
                    <div className="auto-container">
                        <div className="row clearfix">
                            <div className="col-lg-8 col-md-12 col-sm-12 big-column offset-lg-2">
                                <div className="form-inner">
                                    <h2>Leave a Comment</h2>
                                    <form method="post" id="contact-form"> 
                                        <div className="row clearfix">
                                            <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                                <input type="text" name="username" placeholder="Your Name" required={true} />
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                                <input type="email" name="email" placeholder="Your email" required={true} />
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                                <input type="text" name="phone" required={true} placeholder="Phone" />
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                                <input type="text" name="subject" required={true} placeholder="Subject" />
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                                                <textarea name="message" placeholder="Message"></textarea>
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12 form-group message-btn mr-0 centred">
                                                <button className="theme-btn btn-one" type="submit" name="submit-form">Submit Now</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                <section className="google-map-section p_relative">
                    <div className="map-inner p_relative d_block">
                        {/* <div 
                            className="google-map" 
                            id="contact-google-map" 
                            data-map-lat="40.712776" 
                            data-map-lng="-74.005974" 
                            data-icon-path="assets/images/icons/map-marker-2.png"  
                            data-map-title="Brooklyn, New York, United Kingdom" 
                            data-map-zoom="12" 
                            data-markers='{
                                "marker-1": [40.712776, -74.005974, "<h4>Branch Office</h4><p>77/99 New York</p>","assets/images/icons/map-marker-2.png"]
                            }'>
                                    
                        </div> */}
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3838.5964123605536!2d78.02195257797304!3d15.825220745677388!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb5e79b3343a5b9%3A0xd38619d06ceb70dc!2sSunshine%20Advanced%20EYE%20Care!5e0!3m2!1sen!2sin!4v1685174274790!5m2!1sen!2sin" title="Sunshine Advanced Eye Care" width="100%" height="450" style={{border:0}} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </section>

                {/* Subscribe banner hidden on Contact page */}
                {/* <Subscribe /> */}
            </>

    );
  }
  
  export default ContactDetails;